import OperationsController from "../adapters/user.controller";

const getQualificationAverage = async(payload) =>{
    const response = await OperationsController.getQualificationAverage(payload)
    return response;
}


export default getQualificationAverage;